import { addToast, closeAll, cn } from '@heroui/react';
import { ReactNode } from 'react';

interface UseToastApi {
    showError: (message: string, title?: string) => void;
    showSuccess: (message: string, title?: string) => void;
    showWarning: (message: string, title?: string) => void;
    showPromise: <T = never>(
        action: () => Promise<T>,
        isLoading?:ReactNode | null,
        variant?: 'solid' | 'bordered' | 'flat',
        color?: 'danger' | 'default' | 'foreground' | 'primary' | 'secondary' | 'success' | 'warning',
    ) => Promise<T>;
}

export const useHeroToast = (): UseToastApi => {
  const showError = (message: string, title?: string): void => {
    addToast({
      title: title || 'Error',
      description: message,
      color: 'danger',
      variant: 'bordered',
      radius: 'sm',
      timeout: 3000,
      classNames: {
        wrapper: cn([
          'zIndex-100',
        ]),
      },
    });
  };

  const showSuccess = (message: string, title?: string): void => {
    addToast({
      title: title || 'Success',
      description: message,
      color: 'success',
      variant: 'bordered',
      radius: 'sm',
      timeout: 3000,
    });
  };

  const showWarning = (message: string, title?: string): void => {
    addToast({
      title: title || 'Warning',
      description: message,
      color: 'warning',
      variant: 'bordered',
      radius: 'sm',
      timeout: 3000,
    });
  };

  const showPromise = async <T = never>(
    action: () => Promise<T>,
    isLoading?: ReactNode | null,

  ): Promise<T> => {
    addToast({
      title: 'Request pending....',
      description: 'Please wait, operation is in progress.',
      radius: 'sm',
      endContent: isLoading || '',
      color: 'primary',
      variant: 'bordered',
      timeout: 60000,
    });

    try {
      const result = await action();
      closeAll();
      addToast({
        title: 'Success',
        description: 'Operation completed successfully.',
        color: 'success',
        variant: 'bordered',
        radius: 'sm',
        timeout: 1500,
        hideCloseButton: false,
      });

      return result;
    } catch (error) {
      closeAll();
      throw error;
    }
  };

  return { showError, showSuccess, showWarning, showPromise };
};
